import React, { useState } from 'react';
import { Modal, InputNumber, message } from 'antd';

const SessionModal = ({ visible, onClose, initialDuration, onSave }) => {
    const [duration, setDuration] = useState(initialDuration);

    const handleSave = () => {
        if (duration < 1 || duration > 120) {
            message.error('La durée doit être entre 1 et 120 minutes.');
            return;
        }

        const durationInMilliseconds = duration * 60000; 
        localStorage.setItem("sessionDuration", durationInMilliseconds);
        onSave(durationInMilliseconds);
        onClose();
    };

    return (
        <Modal
            title="Modifier la Durée de la Session"
            open={visible}
            onOk={handleSave}
            onCancel={onClose}
            okText="Enregistrer"
            cancelText="Annuler"
        >
            <p>Entrez la nouvelle durée de la session (en minutes) :</p>
            <InputNumber
                min={1}
                max={120}
                value={duration}
                onChange={setDuration}
            />
        </Modal>
    );
};

export default SessionModal;
